export { default } from './DialogActions';
export { default as dialogActionsClasses } from './dialogActionsClasses';
export * from './dialogActionsClasses';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/DialogActions/index.js
// module id = 659
// module chunks = 0